import React from 'react'

function UpdatesArea() {
  return (
	<div className="community-area primary-bg pt-120 pb-175">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="community-wrap">
                <div className="table-responsive-xl">
                  <table className="table mt-0">
                    <thead>
                      <tr>
                        <th scope="col">Updates</th>
                        <th scope="col">available</th>
                        {/* <th scope="col">POSTS</th>
                        <th scope="col">See</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="community-post-type">
                        <th><span>New Updates</span></th>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#"> Self Destruction feature is now avaliable </a>
                              <span>by <a href="/#">Safe Moon Community</a> Yesterday 12 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">Game</a>
                            </div>
                          </div>
                        </th>
                        <td>3/5/2023</td>
                        {/* <td>4</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td> */}
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Vol 3.0 is now avaliable</a>
                              <span>by <a href="/#">Safe Moon Community</a> Last weeak  15 : 30</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">Comics</a>
                            </div>
                          </div>
                        </th>
                        <td>5/6/2023</td>
                        {/* <td>9</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td> */}
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">New Spaceships is now avaliable</a>
                              <span>by <a href="/#">Safe Moon Community</a> Today 1 : 39</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">Home</a>
                              <a href="/#">Store</a>
                            </div>
                          </div>
                        </th>
                        <td>7/8/2023</td>
                        {/* <td>12</td>
                        <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td> */}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="table-responsive-xl">
                  <table className="table">
                  <thead>
                      <tr>
                        <th scope="col">Special Events </th>
                        <th scope="col">Start</th>
                        <th scope="col">End</th>
                        {/* <th scope="col">See</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="community-post-type">
                        <th><span>New Special Events</span></th>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Double Points Event is happening now</a>
                              <span>by <a href="/#">Safe Moon Community</a> Sunday 5 : 20</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">Game</a>
                            </div>
                          </div>
                        </th>
                        <td>3/10/2023</td>
                        <td>14/10/2023</td>
                        {/* <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td> */}
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Galaxy in dangerous Event is Coming</a>
                              <span>by <a href="/#">Safe Moon Community</a> Tuseday 1 : 15</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">Game</a>
                            </div>
                          </div>
                        </th>
                        <td>5/12/2023</td>
                        <td>9/12/2023</td>
                        {/* <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td> */}
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="community-post-wrap">
                            <div className="community-post-content">
                              <a href="/#">Ultra Boss Event is Coming</a>
                              <span>by <a href="/#">Safe Moon Community</a> Yesterday 6 : 19</span>
                            </div>
                            <div className="community-post-tag">
                              <a href="/#">Game</a>
                            </div>
                          </div>
                        </th>
                        <td>7/3/2024</td>
                        <td>12/3/2024</td>
                        {/* <td className="community-bell"><a href="/#"><i className="far fa-bell" /></a></td> */}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="create-topic">
                  <span>Viewing 6 topics - (of 7 Total)</span>
                  <form >
                    <input type="text" placeholder="Must be logged in to create new topics." />
                    <button className="btn">submit</button>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="community-sidebar">
                {/* <div className="widget community-widget mb-30">
                  <div className="community-widget-title mb-25">
                    <h5>share public</h5>
                  </div>
                  <div className="community-sidebar-social">
                    <ul>
                      <li><a href="/#"><i className="fab fa-facebook-f" />Share With Facebook</a></li>
                      <li><a href="/#"><i className="fab fa-twitter" />Share With Twitter</a></li>
                      <li><a href="/#"><i className="fab fa-pinterest-p" />Share With Pinterest</a></li>
                    </ul>
                  </div>
                </div> */}
                <div className="widget community-widget">
                  <div className="community-widget-title mb-25">
                    <h5>new released game</h5>
                  </div>
                  <div className="community-sidebar-game">
                    <ul>
                      <li>
                        <div className="sidebar-new-game-thumb">
                          <a href="/#">
                            <img src="assets/img/blog/rc_post_thumb01.jpg" alt="" />
                          </a>
                        </div>
                        <div className="sidebar-new-game-content">
                          <span>Yesterday 12 : 19</span>
                          <h5><a href="/#">Sky Warrior Game involves</a></h5>
                        </div>
                      </li>
                      <li>
                        <div className="sidebar-new-game-thumb">
                          <a href="/#">
                            <img src="assets/img/blog/rc_post_thumb02.jpg" alt="" />
                          </a>
                        </div>
                        <div className="sidebar-new-game-content">
                          <span>Yesterday 12 : 19</span>
                          <h5><a href="/#">Sky Warrior Game involves</a></h5>
                        </div>
                      </li>
                      <li>
                        <div className="sidebar-new-game-thumb">
                          <a href="/#">
                            <img src="assets/img/blog/rc_post_thumb03.jpg" alt="" />
                          </a>
                        </div>
                        <div className="sidebar-new-game-content">
                          <span>Yesterday 12 : 19</span>
                          <h5><a href="/#">Sky Warrior Game involves</a></h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
  )
}

export default UpdatesArea